import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type FileTemplateType =
  | 'ThermalTicket'
  | 'FullPageTicket'
  | 'FullPageWeightTicket'
  | 'ThermalWeightTicket'
  | 'PurchaseOrder'
  | 'OutboundTicket'
  | 'SalesOrder'
  | 'ShippingSummary'
  | 'BookingInvoice'
  | 'LoadInvoice'
  | 'PackingList'
  | 'BillOfLading'
  | 'InventoryTag'
  | 'ApSettlementReport'
  | 'CheckAp'
  | 'BillAp'
  | 'InvoiceAr'
  | 'PriceList';

export type FileTemplateRecord = QueryAtomResult<
  typeof fileTemplatesQueryAtom
>[number];

export const fileTemplatesQueryAtom = createQueryAtomFactory(
  'settings.fileTemplates',
  (_params: { types?: FileTemplateType[] }) => ({
    fileTemplates: {
      __args: {
        pagination: {
          limit: 1000,
          offset: 0,
        },
      },
      entries: {
        id: true,
        type: true,
        description: true,
        isDefault: true,
        fileId: true,
      },
    },
  }),
  {
    select: (data) => data.fileTemplates.entries ?? [],
  },
);
